const SECRET_PATTERN = /auth|token|secret|key|password|credential/i;
export const isSecretHeader = (name) => SECRET_PATTERN.test(name);
